import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../Components/Paginations";
import axiosInstance from "../../api/axiosInstance";
import { saveAs } from "file-saver";
import { HiDocumentReport } from "react-icons/hi";
import { isJSONString } from "../../User/Pages/Chatbox/ChatBox";
import { FiDownload } from "react-icons/fi";
import { BsFiletypeDoc, BsFiletypeDocx, BsFiletypePdf, BsFiletypeXls, BsFiletypeXlsx } from "react-icons/bs";
import { FaChevronDown, FaFile } from "react-icons/fa";
import { formatDate } from "../../helper";
import ReactSelect, { components } from "react-select";
import { Dropdown } from "react-bootstrap";

interface ReportDataType {
    id: number,
    campaign_name: string,
    message_type: string,
    from: string,
    to: string,
    direction: string,
    media_url: string,
    message: string,
    status: number,
    sms_gateway_name: string,
    retry_sms_id: number,
    error_code: number,
    error_message: string,
    createdAt: string,
    user: {
        id: number,
        name: string,
        email: string,
        role: number
    }
}

export default function CustomReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const [isExporting, setIsExporting] = useState(false);
    const [isReportFetching, setIsReportFetching] = useState(false);
    const [showReport, setShowReport] = useState(false)
    const [selectDateName, setSelectDateName] = useState("Select Date");
    const statusOption = [
        { value: 0, label: "Pending" },
        { value: 1, label: "Sent" },
        { value: 2, label: "Delivered" },
        { value: 3, label: "Undelivered" },
        { value: 4, label: "Failed" },
        { value: 5, label: "Delivery Unknown" },
        { value: 6, label: "Delivery Unconfirmed" },
        { value: 7, label: "Unknown Gateway" },
    ];
    const [users, setUsers] = useState<{ value: number; label: string }[]>([]);
    const [selectUser, setSelectUser] = useState<{ value: number; label: string }[]>([]);
    const [UserSearch, setUserSearch] = useState("");
    const [isUserSearch, setIsUserSearch] = useState(false);
    const [UserInfo, setUserInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [UserPgae, setUserPage] = useState(1);

    const [campaigns, setCampaigns] = useState<{ value: number; label: string }[]>([]);
    const [selectCampaign, setSelectCampaign] = useState<{ value: number; label: string }[]>([]);
    const [CampaignSearch, setCampaignSearch] = useState("");
    const [isCampaignSearch, setIsCampaignSearch] = useState(false);
    const [CampaignInfo, setCampaignInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [CampaignPgae, setCampaignPage] = useState(1);


    const [gateways, setGateways] = useState<{ value: number; label: string }[]>([]);
    const [selectGateways, setSelectGateways] = useState<{ value: number; label: string }[]>([]);
    const [GatewaySearch, setGatewaySearch] = useState("");
    const [isGatewaySearch, setIsGatewaySearch] = useState(false);
    const [GatewayInfo, setGatewayInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [GatewayPgae, setGatewayPage] = useState(1);

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();

    const [Filter, setFilter] = useState<{
        campaign_id: number[],
        message_type: string,
        from: string,
        to: string,
        direction: string,
        status: number[],
        sms_gateway_id: number[],
        retry_sms_id: number | null,
        error_code: number[],
        from_date: string,
        to_date: string,
        user_id: number[],
    }>({
        campaign_id: [],
        message_type: "",
        from: "",
        to: "",
        direction: "",
        status: [],
        sms_gateway_id: [],
        retry_sms_id: null,
        error_code: [],
        from_date: "",
        to_date: "",
        user_id: [],
    });
    const [page, setPage] = useState(1);

    const GetReport = ({ p }: { p: number }) => {
        setIsReportFetching(true);
        let q = `?page=${p}`;
        q += '&limit=10';
        q += `&campaign_id=${Filter.campaign_id ? Filter.campaign_id.join(",") : ""}`;
        q += `&message_type=${Filter.message_type || ""}`;
        q += `&from=${Filter.from?.replaceAll("+", "%2B") || ""}`;
        q += `&to=${Filter.to?.replaceAll("+", "%2B") || ""}`;
        q += `&direction=${Filter.direction || ""}`;
        q += `&status=${Filter.status || ""}`;
        q += `&sms_gateway_id=${Filter.sms_gateway_id ? Filter.sms_gateway_id.join(",") : ""}`;
        q += `&retry_sms_id=${Filter.retry_sms_id || ""}`;
        q += `&error_code=${Filter.error_code ? Filter.error_code.join(",") : ""}`;
        q += `&from_date=${Filter.from_date || ""}`;
        q += `&to_date=${Filter.to_date || ""}`;
        q += `&user.id=${Filter.user_id ? Filter.user_id.join(",") : ""}`;

        axiosInstance.get(`/api/admin/reports/custom${q}`)
            .then((resp: AxiosResponse) => {
                setData(resp.data?.data || []);
                setPage(resp.data?.info?.current_page || 1);
                setInfo(resp?.data?.info);
                setIsReportFetching(false);
                setShowReport(true);
            }).catch(() => { setIsReportFetching(false); });
    };

    const GetUserList = () => {
        axiosInstance.get(`/api/admin/users?limit=50&search=${UserSearch}&page=${UserPgae}`)
            .then((resp: AxiosResponse) => {
                let data = isUserSearch ?
                    resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []
                    : [...users, ...resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []]
                setUsers(data);
                setUserPage(resp.data?.info?.current_page || 1);
                setUserInfo(resp?.data?.info);
                setIsUserSearch(false);
            }).catch(() => { setIsUserSearch(false); });
    };

    const GetCampaignList = () => {
        axiosInstance.get(`/api/admin/sms-campaigns?limit=50&search=${CampaignSearch}&page=${CampaignPgae}`)
            .then((resp: AxiosResponse) => {
                let data = isCampaignSearch ?
                    resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []
                    : [...campaigns, ...resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []]
                setCampaigns(data);
                setCampaignPage(resp.data?.info?.current_page || 1);
                setCampaignInfo(resp?.data?.info);
                setIsCampaignSearch(false);
            }).catch(() => { setIsCampaignSearch(false); });
    };

    const GetGatewayList = () => {
        axiosInstance.get(`/api/admin/sms-gateways?limit=50&search=${GatewaySearch}&page=${GatewayPgae}`)
            .then((resp: AxiosResponse) => {
                let data = isGatewaySearch ?
                    resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []
                    : [...gateways, ...resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []]
                setGateways(data);
                setGatewayPage(resp.data?.info?.current_page || 1);
                setGatewayInfo(resp?.data?.info);
                setIsGatewaySearch(false);
            }).catch(() => { setIsGatewaySearch(false); });
    };

    const DownloadReport = () => {
        setIsExporting(true);
        let q = `?page=${page}`;
        q += '&limit=10';
        q += `&campaign_id=${Filter.campaign_id ? Filter.campaign_id.join(",") : ""}`;
        q += `&message_type=${Filter.message_type || ""}`;
        q += `&from=${Filter.from?.replaceAll("+", "%2B") || ""}`;
        q += `&to=${Filter.to?.replaceAll("+", "%2B") || ""}`;
        q += `&direction=${Filter.direction || ""}`;
        q += `&status=${Filter.status || ""}`;
        q += `&sms_gateway_id=${Filter.sms_gateway_id ? Filter.sms_gateway_id.join(",") : ""}`;
        q += `&retry_sms_id=${Filter.retry_sms_id || ""}`;
        q += `&error_code=${Filter.error_code ? Filter.error_code.join(",") : ""}`;
        q += `&from_date=${Filter.from_date || ""}`;
        q += `&to_date=${Filter.to_date || ""}`;
        q += `&user.id=${Filter.user_id ? Filter.user_id.join(",") : ""}`;

        axiosInstance.get(`/api/admin/reports/custom/download${q}`, { responseType: "blob" })
            .then((resp: AxiosResponse) => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(resp.data)
                link.download = `Custom_Report_${new Date().toISOString()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsExporting(false);
            }).catch(() => { setIsExporting(false); });
    };

    useEffect(() => {
        GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserPgae])

    useEffect(() => {
        if (isUserSearch) GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserSearch])


    useEffect(() => {
        GetCampaignList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CampaignPgae])

    useEffect(() => {
        if (isCampaignSearch) GetCampaignList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CampaignSearch])


    useEffect(() => {
        GetGatewayList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [GatewayPgae])

    useEffect(() => {
        if (isGatewaySearch) GetGatewayList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [GatewaySearch])

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
            GetReport({ p: page });
        }
    };

    const handleClearSearchFilter = () => {
        setShowReport(false)
        setSelectUser([]);
        setSelectGateways([]);
        setSelectCampaign([]);
        setData([]);
        setSelectDateName("Select Date");
        setFilter({
            campaign_id: [],
            message_type: "",
            from: "",
            to: "",
            direction: "",
            status: [],
            sms_gateway_id: [],
            retry_sms_id: null,
            error_code: [],
            from_date: "",
            to_date: "",
            user_id: [],
        });
    };

    const downloadMedia = async (imgUrl: string) => {
        fetch(imgUrl)
            .then((response) => response.blob())
            .then((blob) => {
                saveAs(blob, imgUrl.split("/").pop());
            })
            .catch(() => { });
    };

    return (
        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                                <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                                    <h2 className="mb-0 fs-3 d-block d-md-inline">
                                        SMS Custom Report
                                    </h2>
                                </div>
                            </div>
                            <div className="card-body border-start-0 border-end-0 p-0">
                                <div className="container-fluid">
                                    <div className="row mb-3">
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="campaign">SMS Campaign</label>
                                                <ReactSelect
                                                    name="campaign"
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    options={campaigns}
                                                    filterOption={() => true}
                                                    className='shadow-none'
                                                    value={selectCampaign!}
                                                    onChange={(e) => {
                                                        setSelectCampaign(e as { value: number, label: string }[])
                                                        setFilter({ ...Filter, campaign_id: e.map((item) => item.value) })
                                                    }}
                                                    isClearable
                                                    onInputChange={(inputValue) => {
                                                        setCampaignPage(1)
                                                        setIsCampaignSearch(true);
                                                        setCampaignSearch(inputValue)
                                                    }}
                                                    placeholder="Search and select campaign"
                                                    classNamePrefix="select"
                                                    styles={{
                                                    }}
                                                    components={{
                                                        IndicatorSeparator: () => null,
                                                        DropdownIndicator: () => null,
                                                        MenuList: (props) => (
                                                            <components.MenuList  {...props}>
                                                                {props.children}
                                                                {CampaignInfo?.total_page! > CampaignPgae ? <button className='btn btn-secondary w-100' onClick={() => setCampaignPage(p => p + 1)}>Load more</button> : null}
                                                            </components.MenuList >
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="message_type">Users</label>
                                                <ReactSelect
                                                    name="smscampuser"
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    options={users}
                                                    filterOption={() => true}
                                                    className='shadow-none'
                                                    value={selectUser!}
                                                    onChange={(e) => {
                                                        setSelectUser(e as { value: number, label: string }[])
                                                        setFilter({ ...Filter, user_id: e.map((item) => item.value) })
                                                    }}
                                                    isClearable
                                                    onInputChange={(inputValue) => {
                                                        setUserPage(1)
                                                        setIsUserSearch(true);
                                                        setUserSearch(inputValue)
                                                    }}
                                                    placeholder="Search and select user"
                                                    classNamePrefix="select"
                                                    styles={{
                                                    }}
                                                    components={{
                                                        IndicatorSeparator: () => null,
                                                        DropdownIndicator: () => null,
                                                        MenuList: (props) => (
                                                            <components.MenuList  {...props}>
                                                                {props.children}
                                                                {UserInfo?.total_page! > UserPgae ? <button className='btn btn-secondary w-100' onClick={() => setUserPage(p => p + 1)}>Load more</button> : null}
                                                            </components.MenuList >
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="from">From</label>
                                                <input
                                                    id="from"
                                                    className="form-control"
                                                    placeholder="From Number"
                                                    value={Filter.from}
                                                    onChange={(e) =>
                                                        setFilter({ ...Filter, from: e.target.value })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="to">To</label>
                                                <input
                                                    id="to"
                                                    className="form-control"
                                                    placeholder="To Number"
                                                    value={Filter.to}
                                                    onChange={(e) =>
                                                        setFilter({ ...Filter, to: e.target.value })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="message_type">Message Type</label>
                                                <select
                                                    style={{ width: 240 }}
                                                    value={Filter.message_type || ""}
                                                    className="form-control w-100"
                                                    onChange={(e) => setFilter({ ...Filter, message_type: e.target.value })}
                                                >
                                                    <option value="">All</option>
                                                    <option value="Individual">Individual</option>
                                                    <option value="Broadcast">Broadcast</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="direction">Message Direction</label>
                                                <select
                                                    style={{ width: 240 }}
                                                    value={Filter.direction || ""}
                                                    className="form-control w-100"
                                                    onChange={(e) => setFilter({ ...Filter, direction: e.target.value })}
                                                >
                                                    <option value="">All</option>
                                                    <option value="Outbound">Outbound</option>
                                                    <option value="Inbound">Inbound</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="message_type">Status</label>
                                                <ReactSelect
                                                    name="status"
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    options={statusOption}
                                                    className='shadow-none'
                                                    value={statusOption.filter((item) => Filter.status.includes(item.value))!}
                                                    onChange={(e) => setFilter({ ...Filter, status: e.map((item) => item.value) })}
                                                    isClearable
                                                    placeholder="Search and select status"
                                                    classNamePrefix="select"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="message_type">Date</label>
                                                <Dropdown style={{ zIndex: 999 }} className="w-100">
                                                    <Dropdown.Toggle
                                                        className="form-control w-100 d-flex justify-content-between align-items-center RM_After_Effect"
                                                        variant="transparent"
                                                        style={{ minWidth: 130, border: "1px solid #dfe2e6" }}
                                                    >
                                                        <span className="flex-grow-1 text-start" style={{ color: selectDateName === "Select Date" ? "#8f7f8f" : "black" }}>{selectDateName}</span>
                                                        <FaChevronDown color="#8f7f8f" />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="p-3 Date-Filter-Menu w-100">
                                                        <div className="d-flex flex-column">
                                                            <label className="mb-2 fw-semibold">From</label>
                                                            <input
                                                                type="date"
                                                                name="from"
                                                                value={Filter.from_date}
                                                                onChange={(e) =>
                                                                    setFilter({ ...Filter, from_date: e.target.value })
                                                                }
                                                                className="form-control mb-3"
                                                            />

                                                            <label className="mb-2 fw-semibold">To</label>
                                                            <input
                                                                type="date"
                                                                name="to"
                                                                value={Filter.to_date}
                                                                onChange={(e) =>
                                                                    setFilter({ ...Filter, to_date: e.target.value })
                                                                }
                                                                className="form-control mb-3"
                                                            />

                                                            <div className="d-flex justify-content-between">
                                                                <button
                                                                    className="btn btn-primary w-100 me-1"
                                                                    onClick={() => {
                                                                        if (Filter.from_date && Filter.to_date) {
                                                                            setPage(1)
                                                                            setSelectDateName(`${Filter.from_date} To ${Filter.to_date}`);
                                                                        }
                                                                    }}
                                                                >
                                                                    Apply
                                                                </button>

                                                                <button
                                                                    className="btn btn-secondary w-100 ms-1"
                                                                    onClick={() => {
                                                                        setSelectDateName("Select Date");
                                                                        setFilter({
                                                                            ...Filter,
                                                                            from_date: "",
                                                                            to_date: ""
                                                                        });
                                                                    }}
                                                                >
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-12 col-xxl-3">
                                            <div className="form-group">
                                                <label htmlFor="gateway">SMS Gateway</label>
                                                <ReactSelect
                                                    name="gateway"
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    options={gateways}
                                                    filterOption={() => true}
                                                    className='shadow-none'
                                                    value={selectGateways!}
                                                    onChange={(e) => {
                                                        setSelectGateways(e as { value: number, label: string }[])
                                                        setFilter({ ...Filter, sms_gateway_id: e.map((item) => item.value) })
                                                    }}
                                                    isClearable
                                                    onInputChange={(inputValue) => {
                                                        setGatewayPage(1)
                                                        setIsGatewaySearch(true);
                                                        setGatewaySearch(inputValue)
                                                    }}
                                                    placeholder="Search and select campaign"
                                                    classNamePrefix="select"
                                                    styles={{
                                                    }}
                                                    components={{
                                                        IndicatorSeparator: () => null,
                                                        DropdownIndicator: () => null,
                                                        MenuList: (props) => (
                                                            <components.MenuList  {...props}>
                                                                {props.children}
                                                                {GatewayInfo?.total_page! > GatewayPgae ? <button className='btn btn-secondary w-100' onClick={() => setGatewayPage(p => p + 1)}>Load more</button> : null}
                                                            </components.MenuList >
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 my-3">
                                            <div className="d-flex w-100 gap-2 flex-wrap">
                                                <button
                                                    onClick={() => GetReport({ p: 1 })}
                                                    className="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-100"
                                                    style={{ maxWidth: 180 }}
                                                >
                                                    <HiDocumentReport className="fs-5" />
                                                    Create Report
                                                </button>
                                                <button
                                                    onClick={handleClearSearchFilter}
                                                    className="btn btn-secondary d-flex align-items-center justify-content-center gap-2 w-100"
                                                    style={{ maxWidth: 180 }}
                                                >
                                                    <MdClear className="fs-5" />
                                                    Clear Filter
                                                </button>
                                                <button
                                                    onClick={() => DownloadReport()}
                                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white w-100"
                                                    disabled={isExporting}
                                                    style={{ maxWidth: 180 }}
                                                >
                                                    <BiExport className="fs-5" />
                                                    {isExporting ? "Exporting.." : "Export"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {showReport ?
                                    <React.Fragment>
                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered text-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 200 }}>SR No</th>
                                                        <th style={{ minWidth: 250, width: 250 }}>Campaign Name</th>
                                                        <th style={{ minWidth: 350, width: 350 }}>User</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>User Role</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>From</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>To</th>
                                                        <th style={{ minWidth: 350, width: 350 }}>Message</th>
                                                        <th style={{ minWidth: 350, width: 350 }}>Media</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>Message Type</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>Direction</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>Status</th>
                                                        <th style={{ minWidth: 250, width: 250 }}>Created At</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>SMS Gateway Name</th>
                                                        <th style={{ minWidth: 200, width: 200 }}>Error Code</th>
                                                        <th style={{ minWidth: 250, width: 250 }}>Error Message</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Data && Data[0] ? (
                                                        Data.map((item, i) => (
                                                            <tr>
                                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                                <td>{item?.campaign_name || " - "}</td>
                                                                <td>
                                                                    <p className="mb-0">{item?.user?.name}</p>
                                                                    <p className="mb-0">
                                                                        <small>{item?.user?.email}</small>
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    {item?.user?.role === 1
                                                                        ? "Agent"
                                                                        : item?.user?.role === 2
                                                                            ? "Monitor"
                                                                            : " - "}
                                                                </td>
                                                                <td>{item?.from || " - "}</td>
                                                                <td>{item?.to || " - "}</td>
                                                                <td>{item?.message || " - "}</td>
                                                                <td className="text-center">
                                                                    <div
                                                                        className={`d-flex justify-content-center px-3 gap-2 flex-wrap`}
                                                                    >
                                                                        {!item?.media_url ||
                                                                            JSON.parse(item?.media_url).length === 0 ? (
                                                                            <p className="mb-0">-</p>
                                                                        ) : (
                                                                            isJSONString(item?.media_url) &&
                                                                            JSON.parse(item?.media_url).map(
                                                                                (
                                                                                    item: {
                                                                                        media_url: string;
                                                                                        content_type: string;
                                                                                    },
                                                                                    i: number
                                                                                ) => {
                                                                                    if (
                                                                                        item?.content_type?.startsWith(
                                                                                            "image/"
                                                                                        )
                                                                                    )
                                                                                        return (
                                                                                            <div
                                                                                                className="showImages bg-dark d-block"
                                                                                                key={i}
                                                                                                style={{ height: 75, width: 75 }}
                                                                                            >
                                                                                                <FiDownload
                                                                                                    color="black"
                                                                                                    className="my-1 removeImageBtn p-1"
                                                                                                    style={{
                                                                                                        height: 25,
                                                                                                        width: 25,
                                                                                                    }}
                                                                                                    onClick={() =>
                                                                                                        downloadMedia(item?.media_url)
                                                                                                    }
                                                                                                />
                                                                                                <img
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        height: "100%",
                                                                                                    }}
                                                                                                    src={item?.media_url}
                                                                                                    alt="img"
                                                                                                    className="shadow-none object-fit-contain"
                                                                                                />
                                                                                            </div>
                                                                                        );
                                                                                    else
                                                                                        return (
                                                                                            <div
                                                                                                className={`showImages bg-dark overflow-hidden`}
                                                                                                style={{ height: 75, width: 75 }}
                                                                                                key={i}
                                                                                            >
                                                                                                <FiDownload
                                                                                                    color="black"
                                                                                                    className="my-1 removeImageBtn"
                                                                                                    onClick={() =>
                                                                                                        downloadMedia(item?.media_url)
                                                                                                    }
                                                                                                />
                                                                                                <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                                                                                    <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                                                                                        {item?.content_type ===
                                                                                                            "application/vnd.ms-excel" ? (
                                                                                                            <BsFiletypeXls
                                                                                                                className="w-100 text-success"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        ) : item?.content_type ===
                                                                                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                                                            <BsFiletypeXlsx
                                                                                                                className="w-100 text-success"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        ) : item?.content_type ===
                                                                                                            "application/msword" ? (
                                                                                                            <BsFiletypeDoc
                                                                                                                className="w-100 text-primary"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        ) : item?.content_type ===
                                                                                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                                                                                            <BsFiletypeDocx
                                                                                                                className="w-100 text-primary"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        ) : item?.content_type ===
                                                                                                            "application/pdf" ? (
                                                                                                            <BsFiletypePdf
                                                                                                                className="w-100 text-danger"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            <FaFile
                                                                                                                className="w-100"
                                                                                                                style={{ height: 35 }}
                                                                                                            />
                                                                                                        )}
                                                                                                    </div>
                                                                                                    <p
                                                                                                        className="mb-2 fs-11 text-center"
                                                                                                        style={{ fontSize: 11 }}
                                                                                                    >
                                                                                                        {/* {item?.name} */}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                }
                                                                            )
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>{item?.message_type || " - "}</td>
                                                                <td>{item?.direction || " - "}</td>

                                                                <td className={`text-center ${item?.status === 0 ? 'text-warning fw-bold' :
                                                                    item?.status === 1 ? 'text-success fw-bold' :
                                                                        item?.status === 2 ? 'text-success fw-bold' :
                                                                            item?.status === 3 ? 'text-danger fw-bold' :
                                                                                item?.status === 4 ? 'text-danger fw-bold' :
                                                                                    item?.status === 5 ? 'text-info fw-bold' :
                                                                                        item?.status === 6 ? 'text-info fw-bold' :
                                                                                            item?.status === 7 ? 'text-secondary fw-bold' :
                                                                                                'text-muted'
                                                                    }`}>
                                                                    {item.status === 0 ? "Pending" :
                                                                        item.status === 1 ? "Sent" :
                                                                            item.status === 2 ? "Delivered" :
                                                                                item.status === 3 ? "Undelivered" :
                                                                                    item.status === 4 ? "Failed" :
                                                                                        item.status === 5 ? "Delivery Unknown" :
                                                                                            item.status === 6 ? "Delivery Unconfirmed" :
                                                                                                item.status === 7 ? "Unknown Gateway" : " - "}
                                                                </td>
                                                                <td>{formatDate(item?.createdAt) || " - "}</td>
                                                                <td>{item?.sms_gateway_name || " - "}</td>
                                                                <td>{item?.error_code || " - "}</td>
                                                                <td>{item?.error_message || " - "}</td>
                                                            </tr>
                                                        ))
                                                    ) : !isReportFetching ? (
                                                        <tr>
                                                            <td colSpan={15} height={50}>
                                                                <div className="text-center">
                                                                    <p className="mb-0 fs-5 fw-semibold">
                                                                        No data found
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                            {isReportFetching ? (
                                                <center className="mb-3">
                                                    <i
                                                        className=" my-2 fa loader"
                                                        style={{ fontSize: "30px", color: "black" }}
                                                    ></i>
                                                </center>
                                            ) : null}
                                        </div>
                                        {info && info.total_page ? (
                                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                                <RenderPaginationButtons
                                                    info={info}
                                                    currentPage={page}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        ) : null}
                                    </React.Fragment>
                                    : null
                                }

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
